export enum ActionId {
    PortalMenuFacturen = 132700,
    PortalGegevensFacturen = 144600,
    PortalGegevensWerkbonnen = 144400,
    PortalMenuBonnen = 137300,
    PortalGegevensAfspraken = 144300,
    PortalMenuAfspraken = 132800,
    PortalGegevensInstallaties = 157800,
    PortalMenuInstallaties = 152300,
    PortalGegevensInstalKoeling = 164900,
    PortalGegevensInstalPED = 165000,
    PortalGegevensInstallatiesRVB = 157900,
    PortalGegevensObjecten = 144200,
    PortalMenuObjecten = 153200,
    PortalGegevensBrieven = 167500,
    PortalMenuCorrespondentie = 167400,
    PortalGegevensBestanden = 162600
}